import * as api from 'api/member';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { memberClosetActions } from '../reducer/memberClosetSlice';

export function* getMemberClosetSaga(action: PayloadAction<{ userId: string }>) {
  const { data } = yield call(api.getMemberCloset, action.payload);
  if (data) {
    yield put(memberClosetActions.getMemberClosetSuccess(data));
  } else {
    yield put(memberClosetActions.getMemberClosetFailure(data));
  }
}

export default function* memberClosetSaga() {
  yield all([takeLatest(memberClosetActions.getMemberCloset.type, getMemberClosetSaga)]);
}
